import React from "react";
import className from "../../style.module.scss";

export function ContentBoxTriggerIndicator({ selectedHotspot, id }) {
  if (id !== selectedHotspot) return null;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="18"
      viewBox="0 0 26 18"
      fill="none"
      className={className.tiggerContentBoxSvg}
    >
      <path d="M13 18L0 0L26 1.81705e-06L13 18Z" fill="#FAAC48" />
    </svg>
  );
}

const IncorrectIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9189 11.7477C11.3986 12.2275 12.2264 12.2275 12.7062 11.7477C13.186 11.2679 13.186 10.4401 12.7062 9.96033L9.2142 6.46832L12.7062 2.9763C13.186 2.49652 13.186 1.6687 12.7062 1.18892C12.2264 0.709145 11.3986 0.709145 10.9189 1.18892L7.42685 4.68094L3.93483 1.18892C3.45505 0.709145 2.62723 0.709145 2.14745 1.18892C1.66767 1.6687 1.66767 2.49652 2.14745 2.9763L5.63947 6.46832L2.14745 9.96033C1.66767 10.4401 1.66767 11.2679 2.14745 11.7477C2.62723 12.2275 3.45505 12.2275 3.93483 11.7477L7.42685 8.2557L10.9189 11.7477Z"
      fill="white"
    />
  </svg>
);

const CorrectIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0466 2.86191C12.5769 3.31834 12.6463 4.11444 12.2031 4.65578L6.57188 11.5328C6.1211 12.0834 5.32156 12.158 4.78125 11.6999L1.96392 9.31152C1.42779 8.85701 1.35207 8.05782 1.79332 7.51072C2.25011 6.94434 3.08374 6.86536 3.63876 7.33588L5.43151 8.85569L10.2081 3.02226C10.6671 2.46179 11.4976 2.38935 12.0466 2.86191Z"
      fill="#333333"
    />
  </svg>
);

export function ContentBoxCorrectnessIndicator({ isCorrect, handleClick }) {
  if (isCorrect === false) {
    return (
      <div
        onClick={handleClick}
        className={`${className.correctnessSvg} ${className.incorrect}`}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick();
          }
        }}
      >
        <IncorrectIcon />
      </div>
    );
  }

  if (isCorrect === true) {
    return (
      <div className={`${className.correctnessSvg} ${className.correct}`}>
        <CorrectIcon />
      </div>
    );
  }

  return null;
}
